import ReviewTile from './ReviewTile';

export default ReviewTile;
